// The workout voice's volume slider, 0…1, kept in this browser. 0.7 plays the voice as made; below it fades out
// (−24 dB just above 0), above it rises to +10 dB at the top, for a voice that has to cut through loud music.
export const VOICE_LEVEL_DEFAULT = 0.7;
const STORAGE_KEY = 'mt-voice-level';
const QUIETEST_DB = -24;
const LOUDEST_DB = 10;

export const voiceGain = (level) => {
  if (!(level > 0)) return 0;
  const db =
    level >= VOICE_LEVEL_DEFAULT
      ? ((level - VOICE_LEVEL_DEFAULT) / (1 - VOICE_LEVEL_DEFAULT)) * LOUDEST_DB
      : ((VOICE_LEVEL_DEFAULT - level) / VOICE_LEVEL_DEFAULT) * QUIETEST_DB;
  return 10 ** (db / 20);
};

export const loadVoiceLevel = () => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    const level = stored === null || stored === '' ? NaN : Number(stored);
    return Number.isFinite(level) ? Math.min(1, Math.max(0, level)) : VOICE_LEVEL_DEFAULT;
  } catch {
    return VOICE_LEVEL_DEFAULT;
  }
};

export const saveVoiceLevel = (level) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, String(level));
  } catch {
    // private mode: the level lasts this visit
  }
};
